<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">
      {{ mensagemErro }}
    </v-alert>

    <DataTable
      :classTitle="'Produtos'"
      :tableTitle="'Importar e dispensar materiais'"
      :newRowButtonText="'Importar Produto'"
      :tableHeader="headers"
      :tableData="itens"
      :modalFormComposition="formComposition"
      :onUpdate="update"
      :onInsert="insert"
      :onDelete="deleteItem"
      :onUpdateDataTable="UpdateDataTable"
      :onUpdateoptions="updataOpçoes"
      v-on:datatable-solicitrow="onDataTableSolicitRow"
      :isLoadingRequestDisable="isLoadingRequestDisable"
    ></DataTable>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DatatableMaterialNDispensado";
import store from "@/store/index";

export default {
  components: {
    DataTable,
  },

  data() {
    return {
      isLoadingRequestDisable: false,
      isSolicitarMaterial: false,
      isSolicitarMaterialButtonsDisable: false,
      erro: false,
      mensagemErro: "Erro",
      item: {},

      headers: [
        {
          text: "ID",
          value: "numeroItem",
        },
        {
          text: "Lote",
          value: "lote",
        },
        { text: "Nome Produto", value: "nomeItem" },
        {
          text: "Descrição do Material",
          value: "descricaoItem",
        },
        {
          text: "Validade",
          value: "validade",
        },
        {
          text: "Quantidade Atual",
          value: "quantidadeAtual",
        },
      ],

      //Form composition
      formComposition: [
               {
          title: "Fazer Dispensa automatica",
          type: "checkbox",
          size: 12,
          modelName: "dispensaAutomatica",
        },
        {
          title: "Importar XML",
          type: "file",
          size: 12,
          modelName: "anexoFile",
        },
        {
          title: "Selecionar Unidade",
          type: "select",
          size: 12,
          modelName: "enderecoordemservico",
        }
      ],

      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },

      //Array populado pela função initialize
      itens: [],
      
      //Array Unidade de medida
      unidadesMedida: [],
      teste: [],
    };
  },

  methods: {
    async onDataTableSolicitRow(item) {
      this.isSolicitarMaterial = true;
      this.item = item;
    },

    async solicitarMaterial(solicitacao) {
      try {
        await axios.put("solicitacaodecompra", solicitacao, this.config);
        this.isSolicitarMaterial = false;
      } catch (error) {
        console.log(error);
      }
    },

    FormataStringData(data) {
      var ano = data.split("-")[0];
      var mes = data.split("-")[1];
      var dia = data.split("-")[2];
      var dia2 = dia.substring(0, 2);
      return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
    },

    async UpdateDataTable() {
      try {
        const response = await axios.get("item", this.config);
        
        this.itens = response.data

        for (let item of response.data) {
          item.dataEntrada = this.FormataStringData(item.dataEntrada);
        }

        return response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async updataOpçoes(modalFormName) {
      let novaresposta;

      if (modalFormName == "enderecoordemservico") {
        const responseData = await axios.get(modalFormName, this.config);

        novaresposta = responseData.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      }

      return novaresposta;
    },

    async insert(listItens) {
      const emitObject = {
        listaDeItensEnviados: [listItens.anexoFile],
        numeroUnidade: listItens.numeroenderecoordemservico,
        token: store.state.token,
        descricaoTela: "dispensa",
      }

      if(listItens.dispensaAutomatica) {
        emitObject.dispensaAutomatica = listItens.dispensaAutomatica
      } else {
        emitObject.dispensaAutomatica = false
      }
     
      try {
        this.isLoadingRequestDisable = true;
        await axios.post("itemImport", listItens, this.config);

        
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.isLoadingRequestDisable = true;
        await axios.put("item", reciveItem, this.config);
   
        
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },

    async deleteItem(reciveItem) {
      try {
        this.isLoadingRequestDisable = true;
        await axios.delete("item", {
          data: reciveItem,
          headers: this.config.headers,
        });
       
        return true;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequestDisable = false;
      }
    },
  },
};
</script>